import { Component } from "react";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  render() {
    if (this.state.error) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-[#070709] p-8 text-center">
          <div>
            <p className="font-display text-2xl font-bold text-white">Something went wrong</p>
            <button
              data-testid="error-reload-button"
              onClick={() => window.location.reload()}
              className="mt-6 rounded-full bg-[#e6b800] px-6 py-2.5 font-semibold text-[#070709]"
            >
              Reload
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;